<p *ngIf="address">
    <strong *ngIf="label">{{ label }}</strong><br *ngIf="label && !oneLine"><span *ngIf="oneLine">,</span>
    <ng-container *ngIf="address.droppoint_reference">id: {{ address.droppoint_reference }}<br *ngIf="!oneLine"><span *ngIf="oneLine">,</span></ng-container>
    {{ address.name_1_receiver }}<br *ngIf="!oneLine"><span *ngIf="oneLine">,</span>
    <span *ngIf="address.name_2_receiver">{{ address.name_2_receiver }}<br *ngIf="!oneLine"><span *ngIf="oneLine">,</span></span>
    {{ address.adress_1_receiver }}<br *ngIf="!oneLine"><span *ngIf="oneLine">,</span>
    <span *ngIf="address.adress_2_receiver">{{ address.adress_2_receiver }}<br *ngIf="!oneLine"><span *ngIf="oneLine">,</span></span>

    <ng-container *ngIf="minimal">
        {{ address.city_receiver }}
    </ng-container>
    <ng-container *ngIf="!minimal">
    {{ address.postal_code_receiver }} {{ address.city_receiver }}<br *ngIf="!oneLine"><span *ngIf="oneLine">,</span>
    <ng-container *ngIf="address.country_code_receiver">{{ address.country_code_receiver }}<br *ngIf="!oneLine"><span *ngIf="oneLine">,</span></ng-container>
    {{ address.phone_receiver }}<br *ngIf="!oneLine"><span *ngIf="oneLine">,</span>
    {{ address.email_receiver }}
    </ng-container>
</p>
